// extracted by mini-css-extract-plugin
export default {"font-renta":"AdminPage_font-renta__X0pCe","admin":"AdminPage_admin__9ZCb1","menu":"AdminPage_menu__0bQPj","menuLink":"AdminPage_menuLink__vmQpS","active":"AdminPage_active__XWJyw"};